module.exports = __webpack_public_path__ + "img/header.35f9d5f9.png";